export const NAVIGATION_GROUP = {
    FOOTER_PRIMARY: 'footer_primary',
    FOOTER_SECONDARY: 'footer_secondary',
    HEADER: 'header',
} as const; 